import { motion } from 'framer-motion';
import { MANIFESTO } from '../data/studio';
import { Reveal, Eyebrow } from './Reveal';

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-28 lg:py-44 nebula-mesh" data-testid="manifesto-section">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow>Studio Manifesto</Eyebrow>
          <h2 className="font-celestial text-3xl sm:text-4xl lg:text-5xl font-light text-slate-100 leading-tight">
            Four chapters, one <span className="text-cyan-300 text-glow-cyan">creed</span>
          </h2>
        </Reveal>

        <div className="mt-20 space-y-24 lg:space-y-32">
          {MANIFESTO.map((ch, i) => (
            <div key={ch.num} className={`flex flex-col ${i % 2 === 1 ? 'lg:items-end lg:text-right' : ''}`} data-testid={`manifesto-chapter-${ch.num}`}>
              <motion.span
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 0.14, y: 0 }}
                viewport={{ once: true, margin: '-100px' }}
                transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
                className="font-celestial text-[7rem] sm:text-[10rem] leading-none text-cyan-300 select-none -mb-10 sm:-mb-16"
              >
                {ch.num}
              </motion.span>
              <Reveal delay={0.15}>
                <div className="relative max-w-xl">
                  <h3 className="font-celestial text-2xl sm:text-3xl text-slate-100">{ch.title}</h3>
                  <div className={`w-12 h-px bg-cyan-400/60 my-5 ${i % 2 === 1 ? 'lg:ml-auto' : ''}`} />
                  <p className="text-sm sm:text-base text-slate-400 leading-loose">{ch.text}</p>
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
